import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./LoginRegisterPage.css";

const LoginRegisterPage = () => {
  const [activeTab, setActiveTab] = useState("login");
  const [formData, setFormData] = useState({ phoneNumber: "", password: "" });
  const navigate = useNavigate();

  useEffect(() => {
    if (localStorage.getItem("loggedIn")) navigate("/map");
  }, [navigate]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch("/api/session", {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          Accept: "application/json",
        },
        credentials: "include",
        body: new URLSearchParams({
          email: formData.phoneNumber,
          password: formData.password,
        }).toString(),
      });

      if (response.ok) {
        const userData = await response.json();
        localStorage.setItem("loggedIn", "true");
        if (userData?.id) localStorage.setItem("userId", String(userData.id));
        navigate("/map");
      } else {
        alert("ورود ناموفق بود! نام کاربری یا رمز عبور اشتباه است.");
      }
    } catch {
      alert("مشکل در اتصال به سرور!");
    }
  };

  return (
    <div className="login-page">
      <div className="login-left-panel">
        <img src="/logo.png" alt="لوگو" className="brand-logo" onError={(e) => { e.target.src = "/logo192.png"; }} />
        <div className="brand-title">سامانه ردیابی مارکو</div>
        <div className="brand-subtitle">
          موقعیت وسایل نقلیه خود را در هر لحظه
          <br />
          به صورت زنده رصد کنید
        </div>
        <div className="brand-dots">
          <div className="brand-dot active"></div>
          <div className="brand-dot"></div>
          <div className="brand-dot"></div>
        </div>
      </div>

      <div className="login-right-panel">
        <div className="login-form-header">
          <img src="/logo.png" alt="لوگو" className="form-logo" onError={(e) => { e.target.src = "/logo192.png"; }} />
        </div>

        <div className="login-tabs">
          <button
            className={`login-tab-btn ${activeTab === "login" ? "active" : ""}`}
            onClick={() => setActiveTab("login")}
          >
            ورود
          </button>
          <button
            className={`login-tab-btn ${activeTab === "register" ? "active" : ""}`}
            onClick={() => setActiveTab("register")}
          >
            ثبت نام
          </button>
        </div>

        {activeTab === "login" ? (
          <form className="login-form" onSubmit={handleLogin}>
            <div className="login-field">
              <label>نام کاربری / شماره موبایل</label>
              <div className="login-field-input-wrap">
                <span className="login-field-icon">👤</span>
                <input
                  type="text"
                  name="phoneNumber"
                  placeholder="نام کاربری یا شماره موبایل"
                  value={formData.phoneNumber}
                  onChange={handleChange}
                  required
                />
              </div>
            </div>
            <div className="login-field">
              <label>رمز عبور</label>
              <div className="login-field-input-wrap">
                <span className="login-field-icon">🔒</span>
                <input
                  type="password"
                  name="password"
                  placeholder="رمز عبور خود را وارد کنید"
                  value={formData.password}
                  onChange={handleChange}
                  required
                />
              </div>
            </div>
            <button type="submit" className="login-submit-btn">ورود به سامانه</button>
          </form>
        ) : (
          <form className="login-form">
            <div className="login-field">
              <label>کد ثبت‌نام ۶ رقمی</label>
              <div className="login-field-input-wrap">
                <span className="login-field-icon">🔑</span>
                <input type="text" placeholder="کد ثبت نام ۶ رقمی" maxLength={6} required />
              </div>
            </div>
            <div className="login-field">
              <label>شماره تلفن داخل موبایل مشتری</label>
              <div className="login-field-input-wrap">
                <span className="login-field-icon">📱</span>
                <input type="text" placeholder="شماره موبایل" required />
              </div>
            </div>
            <div className="login-field">
              <label>رمز عبور</label>
              <div className="login-field-input-wrap">
                <span className="login-field-icon">🔒</span>
                <input type="password" placeholder="رمز عبور را انتخاب کنید" required />
              </div>
            </div>
            <button type="submit" className="login-submit-btn">ثبت نام</button>
          </form>
        )}

        <div className="login-footer-text">
          سامانه ردیابی مارکو &mdash; نسخه 2.0.1
        </div>
      </div>
    </div>
  );
};

export default LoginRegisterPage;
